// src/PrivacyPolicy.js
import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div class="container mx-auto px-9 relative flex flex-col items-center gap-2.5 md:border-2 py-6 rounded-3xl min-h-[100%] mb-12">
            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>Privacy Policy for Vortexi</p>
            <p>Effective date: 10.10.2024</p>

            <p>
                At Vortexi, accessible from [insert your extension's URL or Chrome Web Store link], your privacy is of utmost importance to us. This Privacy Policy outlines the types of personal information we collect, how we use it, and your rights regarding your information.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>Information We Collect</p>
            <p>
                We collect the following types of personal information when you use our Chrome extension:
            </p>
            <ul>
                <li><strong className='font-montserrat-semibold'>Email Address:</strong> We collect your primary email address to facilitate email sending through our extension.</li>
                <li><strong className='font-montserrat-semibold'>Display Name:</strong> Your display name is used to personalize your email experience.</li>
                <li><strong className='font-montserrat-semibold'>Profile Image URL:</strong> If available, this information is used to enhance the visual presentation of your emails.</li>
            </ul>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>How We Use Your Information</p>
            <p>
                We use the information we collect to: Provide and maintain our service.
                <li>Improve user experience by personalizing your interactions with the extension.</li>
                <li>Facilitate the authentication process with Gmail and Outlook.</li>
                <li>Enable email composition and sending functionalities.</li>
            </p>
            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>Data Storage</p>
            <p>
                We store your information securely within the extension to provide you with quick access and improve the efficiency of the email-sending process. Access tokens and user information are stored locally to minimize the need for repeated authentication. This means that no information is stored permanently; all data is securely stored within your Chrome browser environment.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>Sharing Your Information</p>
            <p>
                We do not share your personal information with third parties without your explicit consent, except as required by law or as necessary to provide our services.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>Changes to This Privacy Policy</p>
            <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>Contact Us</p>
            <p>
                If you have any questions about this Privacy Policy, please contact us at vortexiai.business@gmail.com.
            </p>
        </div>
    );
};

export default PrivacyPolicy;